import { render, staticRenderFns } from "./ListOfObjects.vue?vue&type=template&id=1ef7c392&"
import script from "./ListOfObjects.vue?vue&type=script&lang=js&"
export * from "./ListOfObjects.vue?vue&type=script&lang=js&"
import style0 from "./ListOfObjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports